<template>
  <div class="selected-coin">
    <div class="show-selected-coin">
      <div class="coin">
        <img :src="require('../../../assets/coins/' + coin + '.svg')" alt="" />

        <div class="name">
          <span class="name-span">{{ $coinLabel[coin] }}</span>
          <span class="relation-name">{{ coin }}</span>
        </div>
      </div>

      <div class="line"></div>

      <div class="select-type">
        <button
          @click="
            type = 'usdt';
            goto();
          "
          :class="{
            'gray-btn': type === 'usdt',
            'solid-gray-btn': type === 'toman',
          }"
        >
          USDT | تتر
        </button>
        <button
          @click="
            type = 'toman';
            goto();
          "
          :class="{
            'gray-btn': type === 'toman',
            'solid-gray-btn': type === 'usdt',
          }"
        >
          TMN | تومان
        </button>
      </div>
    </div>

    <div class="search-coin">
      <label>
        <img src="../../../assets/icon/search.png" alt="" />
        <input
          v-model="regex"
          type="search"
          class="search-input"
          placeholder="جستجو در رمز ارزها"
        />
      </label>
    </div>

    <div class="table-coin">
      <table>
        <tr class="stiky">
          <th class="right-text">رمز ارز</th>
          <th class="center-text">قیمت واحد</th>
          <th class="left-text">تغییرات</th>
        </tr>
        <tr
          @click="selectMarketType(item.sourceCoinSymbol)"
          v-for="(item, index) in filterCoins() "
          :key="index"
        >
          <td class="td-right">
            <div class="name-coin">
<!--              <img-->
<!--                :src="require('../../../assets/coins/' + $coinUnit[item.destCoinSymbol] + '.png')"-->
<!--                alt=""-->
<!--              />-->

              <img :src="require('../../../assets/coins/'+$coin2Snake[item.sourceCoinSymbol]+'.svg')" alt="">

              <div class="name-sec">
                <span class="name">{{  $coinLabel[item.sourceCoinSymbol] }}</span>
                <small>{{ $coinsUnit[item.sourceCoinSymbol.toUpperCase()] }}</small>

              </div>
            </div>
          </td>
          <td class="number td-center">
            {{ $toLocal(item.price, type=='toman' ? $decimal['TOMAN'] : $decimal['TETHER']) }}
          </td>

          <td
            class="number td-left"
            :class="{ red: item.priceChange24hr < 0, green: item.priceChange24hr > 0 }"
          >
           % {{ $toLocal(item.priceChange24hr,2) }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import {
  tradeTo,
  tradeFrom,
  Loop
} from "@/lib/reuseableFunction";

export default {
  name: "selected-coin",
  props: {
    coin: String,
  },

  data() {
    return {
      type: "toman",
      regex: "",
coins:[],
       TomanCoin: 'market_type=BITCOIN_TOMAN' +
          '&market_type=BITCOIN_CASH_TOMAN' +
          '&market_type=ETHEREUM_TOMAN' +
          '&market_type=LITE_COIN_TOMAN' +
          '&market_type=BINANCE_COIN_BSC_TOMAN' +
          '&market_type=STELLAR_TOMAN' +
          '&market_type=TRON_TOMAN' +
          '&market_type=CELO_TOMAN' +
          '&market_type=RIPPLE_TOMAN' +
          '&market_type=DOGE_COIN_TOMAN' +
          '&market_type=MATIC_TOMAN' +
          '&market_type=TETHER_TOMAN',
      TetherCoin: 'market_type=BITCOIN_TETHER' +
          '&market_type=BITCOIN_CASH_TETHER' +
          '&market_type=ETHEREUM_TETHER' +
          '&market_type=LITE_COIN_TETHER' +
          '&market_type=BINANCE_COIN_BSC_TETHER' +
          '&market_type=MATIC_TETHER' +

          '&market_type=STELLAR_TETHER' +
          '&market_type=TRON_TETHER' +
          '&market_type=RIPPLE_TETHER' +
          '&market_type=DOGE_COIN_TETHER' +
          '&market_type=CELO_TETHER',
tableContent:[],
    };
  },
  computed:{
    setcoins(){

      let coins= '';
      coins =   this.type=='toman' ? this.$store.state.usd : this.$store.state.usdt;
      this.tableContent.sort(
          (a, b) =>
              this.$sortCoins.indexOf(a.sourceCoinSymbol) -
              this.$sortCoins.indexOf(b.sourceCoinSymbol)
      );
      return coins
    }

  },

  watch :{
    'setCoins'(){
      this.state.loading=true
      let usd
      let usdt
      usd = this.$store.state.usd
      usdt = this.$store.state.usdt
      this.type =='toman'? this.tableContent =usd : this.tableContent = usdt


      this.tableContent.sort(
          (a, b) =>
              this.$sortCoins.indexOf(a.sourceCoinSymbol) -
              this.$sortCoins.indexOf(b.sourceCoinSymbol)
      );
      this.state.loading = false;
    }
  },
  methods: {
    selectMarketType(e) {
e = this.$coinsChange[e]
      // e = e.toUpperCase()
      //
      // if (e.includes('-')) {
      //
      //   e = e.split('-')
      //   e = e.join('_')
      //   console.log(e)
      //   if (e.includes('NETWORK')) {
      //     console.log(e)
      //     e = e.replace('_NETWORK', '')
      //   }
      // }


      this.state.marketType = e;
      this.$router.push(e);
    },
    goto() {
      this.$router.push(
          `/trade/${this.type == "usdt" ? "TETHER" : "TOMAN"}/${
              this.$route.params.tradeFrom
          }`
      );
    },

    filterCoins() {

      return this.setcoins.filter((coin) => {
        if (
            coin.sourceCoinSymbol.toLowerCase().includes(this.regex.toLowerCase())

            ||
            this.$coinLabel[coin.sourceCoinSymbol]
                .toLowerCase()
                .includes(this.regex.toLowerCase())
        ) {
          return coin;
        }
      });

    },


  },
};
</script>

<style lang="scss" scoped>
.selected-coin {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 8px;

  .show-selected-coin {
    display: flex;
    flex-direction: row;
    color: #fbfbfd;
    flex-wrap: wrap;
    row-gap: 10px;
    justify-content: space-between;

    .coin {
      display: flex;
      flex-direction: row;
      gap: 8px;

      img {
        width: 32px;
        height: 32px;
      }

      .name {
        display: flex;
        flex-direction: column;
        text-align: right;

        .name-span {
          font-size: clamp(14px, 2vw, 16px);
          color: #fbfbfd;
        }

        .relation-name {
          font-size: clamp(8px, 2vw, 10px);
          color: rgba(215, 200, 200, 1);
        }
      }
    }

    .line {
      width: 2px;
      border-right: 1px solid #1199fa;
    }

    .select-type {
      gap: 10px;
      display: flex;
      flex-direction: row;

      button {
        width: 92px;
        height: 35px !important;
      }
    }
  }

  .search-coin {
    .search-input {
      width: 100%;
      background-color: rgba(0, 0, 0, 0.3);
      border-radius: 4px;
      color: #fbfbfd;
      height: 30px;
      padding-right: 30px;
    }

    label {
      position: relative;

      img {
        position: absolute;
        top: 25%;
        right: 5px;
      }
    }
  }

  .table-coin {
    height: 305px;
    overflow: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    .stiky {
      position: sticky;
      top: 0;
      height: 30px;
      background:transparent;
      z-index: 3;




    .center-text {
        padding-left: 5px;
      }
      .right-text {
        text-align: right;
        padding-right: 10px;
      }

      .left-text {
        text-align: left;
      }

      &:hover {
        background: transparent !important;
      }
    }

    .td-right {
      text-align: right;
    }

    .td-center {
      text-align: center;
    }

    .td-left {
      text-align: left;
    }

    table {
      table-layout: fixed;

      th {
        font-size: clamp(10px, 2vw, 12px);
        text-align: center;
      }

      tr {
        height: 26px;
        &:hover {
          cursor: pointer;
          background: linear-gradient(
            259.33deg,
            rgba(28, 52, 102, 0) 7.64%,
            rgba(28, 52, 102, 0.35) 52.12%,
            rgba(20, 37, 69, 0.24) 83.62%
          );
        }
      }

      td {
        font-size: clamp(10px, 2vw, 12px);
        text-align: center;
      }
    }

    .name-coin {
      display: flex;
      flex-direction: row;
      gap: 5px;

      img {
        width: 25px;
        height: 25px;
      }

      .name-sec {
        display: flex;
        flex-direction: column;
        gap: 5px;
        text-align: right;
        align-items: start;

        span {
          font-size: 10px;
          display: ruby;
        }

        small {
          color: #8c8585;
          font-size: 10px;
        }
      }
    }
  }
}
</style>
